import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useEffect, useState } from 'react';

/**
 * Use to emit a `true` value for one render cycle. This is useful when you need to
 * pass true to a component to trigger an action, like scrolling to the top.
 */
export function useBooleanEmitter(): [value: boolean, onEmit: () => void] {
  const [value, setValue] = useState(false);
  const onEmit = useEventCallback(() => {
    setValue(true);
  });

  useEffect(() => {
    if (value) {
      setValue(false);
    }
  }, [value]);

  return [value, onEmit];
}
